import { gql } from 'graphql-tag';

import { MemberInfoFragment } from './MemberInfo';

export const BookingDetailsFragment = gql`
  ${MemberInfoFragment}
  fragment BookingDetails on BookingType {
    locationId
    skuId
    member {
      ...MemberInfo
    }
  }
`;
